import { Plane, Wallet, Sparkles } from "lucide-react";

export const apps = [
  {
    id: "tabitto",
    name: "Tabitto",
    icon: Plane,
    color: "#3b82f6", // blue-500
    colorClass: "bg-blue-500",
    textColorClass: "text-blue-500",
    lightBgClass: "bg-blue-50",
    illustration: "/illustrations/travel-plans.svg",
    url: import.meta.env.DEV ? "http://localhost:5173" : "https://tabitto.tabipla.app",
  },
  {
    id: "waritto",
    name: "Waritto",
    icon: Wallet,
    color: "#10b981", // emerald-500
    colorClass: "bg-emerald-500",
    textColorClass: "text-emerald-500",
    lightBgClass: "bg-emerald-50",
    illustration: "/illustrations/pizza-sharing.svg",
    url: import.meta.env.DEV ? "http://localhost:5174" : "https://waritto.tabipla.app",
  },
  {
    id: "mekke",
    name: "Mekke",
    icon: Sparkles,
    color: "#6366f1", // indigo-500
    colorClass: "bg-indigo-500",
    textColorClass: "text-indigo-500",
    lightBgClass: "bg-indigo-50",
    illustration: "/illustrations/exploring.svg",
    url: import.meta.env.DEV ? "http://localhost:5175" : "https://mekke.tabipla.app",
  },
] as const;

export type AppId = (typeof apps)[number]["id"];
